export default function Exibir(medicamentos) {

  let dados = []
  medicamentos.map((medicamento) => {
    dados.push({
      substancia: medicamento.substancia,
      nomeMedicamento: medicamento.medicamento,
      apresentacao: medicamento.apresentacao,
      duracaoTratamento: medicamento.duracaoTratamento + ' ' + medicamento.periodoTratamento,
      posologia: medicamento.posologia,
      observacao: medicamento.observacao,
      idMedicamento: medicamento.idMedicamento
    })
  })

  return dados
}